import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';

@Component({
    selector: 'app-delete-season',
    templateUrl: './delete-season.component.html',
    styleUrls: ['./delete-season.component.css'],
    standalone: false
})
export class DeleteSeasonComponent implements OnInit {

  seasonId:number = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public deleteSeasonDialog: MatDialogRef<DeleteSeasonComponent>,
  public nav: NavBarComponent,
  private seasonManagerService: SeasonManagerService,

) {
}
  ngOnInit(): void {
    if(this.data){
      this.seasonId = this.data.seasonId;
     }
  }

  cancel(){
    this.deleteSeasonDialog.close({"option": "cancel"});
  }

  deleteSeason(){
    this.nav.toggleLoading(true);
   
    this.seasonManagerService.deleteSeasonById(Number(this.seasonId)).pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe(() =>{
      this.deleteSeasonDialog.close({"option": "delete"});
      this.nav.toggleLoading(false);
  
    });
  
  }
}
